import FilterBase from "./base";

export default class FilterObjectModule extends FilterBase {

    constructor(config, notification) {
        super(config, notification, "objectSelect");
        if (this.component === null) {
            return;
        }
        this.checkboxes = this.component.querySelectorAll('.items-list__column input[type="checkbox"]');
        this.checkAllCheckbox = this.component.querySelector('.check-all input[type="checkbox"]');
        this.bindCloseButton(this.onCloseFilter);
        this.bindClearFiltersButton(this.onClearFilter);
        this.bindCheckboxCheck();
        this.bindCheckAllCheckbox();
        const searchParams = new URLSearchParams(config.settings.savedFilters);
        let facilityIds = searchParams.get("facilities");
        if (facilityIds !== null) {
            const facilityIdsArr = facilityIds.split(',');
            this.checkboxes.forEach(checkbox => {
                if (facilityIdsArr.includes(checkbox.value)) {
                    checkbox.checked = 1;
                    this.addItemToList(checkbox);
                }
            });
        }
        this.updateInput();
    }

    updateInput = () => {
        switch (this.selectedData.length) {
            case 0:
                this.input.value = "";
                this.hideCounter();
                break;

            case 1:
                this.input.value = this.selectedData[0].name;
                this.hideCounter();
                break;
        
            default:
                this.input.value = "Wiele obiektów";
                this.showCounter();
                break;
        }

        this.selectedData = [...new Map(this.selectedData.map(item => [item.id, item])).values()];
        this.checkAllCheckbox.checked = this.selectedData.length === this.checkboxes.length;
    }
}